<template>
    <mySubPage>
        <div slot="header">
            <myNav>信誉值流动历史[{{org_cname}}]</myNav>
        </div>
        <div class="relative fillh">
            <myOrgCrSn :org_id="org_id" v-if="org_id != ''" url="org-cr-sn/list-by-org"></myOrgCrSn>
        </div>
    </mySubPage>
</template>

<script>
    import myOrgCrSn from "../../../components/myOrgCrSn"
    export default {
        components:{
            myOrgCrSn
        },
        data:function(){
            return{
                org_id:'',
                org_cname:''
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            var para = this.$base.getRequest();
            this.org_id = para.org_id || '';
            this.org_cname = para.org_cname || '';
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/org/shop/crsn.vue